module.exports = __webpack_public_path__ + "static/img/video-call.8b1be5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video-call.jpg
// module id = zBRF
// module chunks = 1